import React from 'react';
import { IonPage, IonContent, IonCard, IonCardContent, IonIcon, IonButton, IonSpinner, IonText } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { leafOutline } from 'ionicons/icons';
import { useDashboard, type HomeItem } from '../../application/use-cases/measurements/useDashboard';
import StationHome from '../components/station/StationHome';
import LotHome from '../components/lot/LotHome';

const Dashboard: React.FC = () => {
  const history = useHistory();
  const { items, selected, setSelectedKey, loading, error, triggeredAlerts } = useDashboard();
  // Las estaciones de lo elegido: las del lote, o la estación suelta.
  const deviceIdsOf = (item: HomeItem) => (item.kind === 'lot' ? item.lot.stations.map((s) => s.id) : [item.device.id]);
  const alertsOf = (item: HomeItem) => triggeredAlerts.filter((a) => deviceIdsOf(item).includes(a.deviceId));
  const selectedAlerts = selected ? alertsOf(selected) : [];

  const switcher =
    items.length > 1 && selected ? (
      <div className="home-switcher" role="tablist" aria-label="Lotes y estaciones">
        {items.map((item) => (
          <button key={item.key} role="tab" aria-selected={item.key === selected.key} onClick={() => setSelectedKey(item.key)}>
            {item.kind === 'lot' && <IonIcon icon={leafOutline} />}
            {item.kind === 'lot' ? item.lot.name : item.device.name}
            {alertsOf(item).length > 0 && <span className="dot" aria-label="con alertas activas" />}
          </button>
        ))}
      </div>
    ) : undefined;
  const hero = { switcher, alertCount: selectedAlerts.length };

  return (
    <IonPage>
      <IonContent fullscreen>
        {loading && items.length === 0 && (
          <div className="ion-text-center ion-padding">
            <IonSpinner color="primary" />
          </div>
        )}

        {!loading && error && (
          <IonText color="danger">
            <p className="ion-padding">{error}</p>
          </IonText>
        )}

        {!loading && !error && items.length === 0 && (
          <IonCard>
            <IonCardContent>
              <p style={{ marginTop: 0 }}>
                Todavía no tenés estaciones. Sumá tu estación DOMIOT para ver el clima, la lluvia, el viento y la humedad de
                suelo de tu campo en tiempo real — y regar desde acá si tiene válvulas.
              </p>
              <IonButton expand="block" onClick={() => history.push('/app/devices')}>
                Agregar mi estación
              </IonButton>
            </IonCardContent>
          </IonCard>
        )}

        {/* key: al cambiar de lote o estación se monta de cero (sin datos del anterior). */}
        {selected &&
          (selected.kind === 'lot' ? (
            <LotHome key={selected.key} lot={selected.lot} devices={selected.devices} hero={hero} />
          ) : (
            <StationHome key={selected.key} station={selected.device} hero={hero} />
          ))}
      </IonContent>
    </IonPage>
  );
};

export default Dashboard;
